<div style="position: absolute; bottom: 0; left: 0;z-index: -1; margin-bottom: -14px; overflow: hidden; width: 100%;
  max-height: 300px;">
  <img style="width: 100%;
  height: auto;
  display: block;"  src="assets/img/box.svg" >
</div>
